export const OG_PLACEHOLDER_POINTS = 8_847_570;

export const FIRST_POINTS_DROP_TS = 1706882400000; // 2 Feb 14:00 UTC

export enum LEAGUE {
	DIAMOND = 'Diamond',
	GOLD = 'Gold',
	SILVER = 'Silver',
	BRONZE = 'Bronze',
	UNRANKED = 'Unranked',
}

type LeagueConfig = {
	league: LEAGUE;
	range: string;
	imageUrl: string;
	rangeStart: number;
	color: string;
	textColorClass: string;
};

export const UNRANKED_LEAGUE_CONFIG: LeagueConfig = {
	league: LEAGUE.UNRANKED,
	range: '$0 - $5k USD',
	imageUrl: '/assets/images/points/unranked-league-icon.png',
	rangeStart: 0,
	color: 'var(--text-label)',
	textColorClass: 'text-text-label',
};

export const LEAGUE_LIST: LeagueConfig[] = [
	{
		league: LEAGUE.DIAMOND,
		range: '$10m - $50m USD',
		imageUrl: '/assets/images/points/diamond-league-icon.png',
		rangeStart: 10_000_000,
		color: 'var(--drift-points-gradient)',
		textColorClass: 'drift-points-text-gradient',
	},
	{
		league: LEAGUE.GOLD,
		range: '$1m - $10m USD',
		imageUrl: '/assets/images/points/gold-league-icon.png',
		rangeStart: 1_000_000,
		color: 'var(--drift-league-gold)',
		textColorClass: 'league-gold-text-gradient',
	},
	{
		league: LEAGUE.SILVER,
		range: '$100k - $1m USD',
		imageUrl: '/assets/images/points/silver-league-icon.png',
		rangeStart: 100_000,
		color: 'var(--drift-league-silver)',
		textColorClass: 'league-silver-text-gradient',
	},
	{
		league: LEAGUE.BRONZE,
		range: '$5k - $100k USD',
		imageUrl: '/assets/images/points/bronze-league-icon.png',
		rangeStart: 5_000,
		color: 'var(--drift-league-bronze)',
		textColorClass: 'league-bronze-text-gradient',
	},
	UNRANKED_LEAGUE_CONFIG,
];

export const HIGHEST_LEAGUE_CONFIG = LEAGUE_LIST.reduce(
	(curr, leagueConfig) => {
		if (leagueConfig.rangeStart > curr.rangeStart) {
			return leagueConfig;
		}

		return curr;
	},
	UNRANKED_LEAGUE_CONFIG
);
